
<template>
  <div class="with-draw">
    <Head :info="headInfo"></Head>
    <div class="container">
        <div class="balance">
            <div class="balance-title">可提现金额(元)</div>
            <div class="balance-detail">{{info.cashOut}}  
                <div class="with-draw-list" @click="goNext('/record')">提现记录</div>
            </div>
            <div class="history"><span>结算中</span><span class="history-detail">{{info.settleAccounts}}</span>    <span>累计收入</span><span class="history-detail">{{info.income}}</span></div> 
        </div>
        <div class="choose-title">提现到</div>
        <div class="accounts">
            
            <div class="each-account" v-for="(item,index) in accountList" @click="chooseMethods(item)" :key="index">
                <img :src="item.icon" alt="">
                <div class="account-name">{{item.name}}</div>
                <div class="choose-box"><img v-if="choosedValue==item.value" src="../../assets/images/choose.png" alt=""></div>
            </div>
            <!-- </van-radio-group> -->
        </div>
        <div class="xieyi" @click="readyCheck">
            <van-checkbox v-model="checked" checked-color="#ee0a24"></van-checkbox>
            <div>

            我已阅读并同意<span class="xieyi-name" @click.stop="showDialog">《网上管家婆合作关系协议》《网上管家婆提现规则》</span>
            </div>
        </div>
        <div class="btnbox">
            <van-button :disabled="disabled" @click="submit()" round size="large" color="linear-gradient(to right, #F5251B, #FB6149)">
            提现
            </van-button>
        </div>
    </div>
    <van-overlay :show="show" @click="show = false">
        <div class="dialog-box">
            <div class="wrapper" @click.stop>
                <div class="dialog-title">阅读协议<span>《网上管家婆合作协议》《网上管家婆提现规则》</span>，同意后继续</div>
                <div class="dialog-msg">
                                网上管家婆合作伙伴协议：
                <div>
1、您完成登录后，即视为您同意和授权第三方站点和软件使用网上管家婆数据接口调用您微信账号和与该账号关联的店铺或系统的相关信息数据，并接受本协议全部内容。
                </div><div>
2、第三方站点和软件的质量和品质由第三方独立负责，网上管家婆仅提供登录接口，对第三方站点或软件的服务等不承担任何责任。如因第三方站点或软件存在漏洞、瑕疵、故障、病毒等原因造成您相关权益受损的，您可以请网上管家婆协调，但您不应就登录和使用第三方站点或软件的后果但您不应就登录和使用第三方站点
                </div>
                </div>
                <div class="dialog-btn">
                    <van-button round @click="ready" :disabled="readed" size="large" color="linear-gradient(to right, #F5251B, #FB6149)">
                    我已阅读并同意
                    </van-button>
                </div>
            </div>
        </div>
    </van-overlay>
  </div>
</template>

<script type="text/babel">

import Head from '@/component_basics/Head'
import Cell from '@/component_basics/Cell'
// 组件
export default {
  name: 'withDraw',
  components: {Head,Cell},
  data() {
    return {
        headInfo:{
            name: '提现'
        },
        info:{
            cashOut: 520.00,
            settleAccounts: 298.0,
            income: 400
        },
        show:false,
        checked:false,
        disabled: true,
        readed:true,
        radio:'',
        choosedValue:1,
        accountList:[
            {
                icon:require('../../assets/images/wx.png'),
                name:'微信零钱',
                value:1
            },{
                icon:require('../../assets/images/zfb.png'),
                name:'支付宝',
                value:2
            },{
                icon:require('../../assets/images/yinhang.png'),
                name:'银行卡',
                value:3
            }
        ]

    };
  },
  created() {
      this.getUserInfo()
  },
 mounted() {
 },
  methods: {
      chooseMethods(item) {
          this.choosedValue = item.value
      },
      showDialog() {
          this.show = true
          let _this = this
        _this.readed = true
          setTimeout(function() {
              _this.readed = false
          },3000)
      },
      goNext(url,param) {

          this.$router.push({
              path:url,
              query: param
          })
      },
      submit() {
          let urlDic = {
              1: 'wx',
              2: 'zfb',
              3: 'bank'
          }
          this.goNext('/toWx',{target:urlDic[this.choosedValue],money:this.info.cashOut})
      },
      ready() {
          this.show = false
      },
      getUserInfo() {
          console.log(this.$route)
        let param = {
            // refereeId: this.$route.query.refereeId
        }
        this.$services.getTkDataById({method:'post',data:param}).then(res=> {
        
        this.info = res.data[0]
        })
    },
      readyCheck() {
          this.checked = !this.checked
          this.disabled = !this.checked
          
      }
  }
};
</script>

<style lang="less" scoped>
 .with-draw{
     background-color: @colorBg;
     .balance{
         background: url('../../assets/images/charge.png');
         background-size: 100%;
         height: 145px;
         margin: 13px;
         padding: 22px 0 20px 24px;
         color: #fff;
         &>div{
             display: flex;
             justify-content: flex-start;
         }
         .balance-title{
             font-family: 'PingFang-SC-Medium';
             opacity: 0.58;
             font-size: 15px;
         }
         .balance-detail{
             margin-top: 16px;
             font-weight: bold;
             margin-bottom: 15px;
             font-size: 40px;
             justify-content: space-between;
             align-items: center;
             .with-draw-list{
                 width: 77px;
                 height: 26px;
                 border-radius: 8px 0 0 8px;
                 background-color: #EB3831;
                 font-size: 13px;
                 opacity: 0.75;
                 display: flex;
                 align-items: center;
                 justify-content: center;
             }

         }
         .history{
             font-size: 14px;
             span{
                opacity: 0.58;
             }
             .history-detail{
                 margin-right: 34px;
                 opacity: 1;
                 margin-left: 6px;
             }
         }
     }
     .choose-title{
         font-size: 17px;
         font-weight: bold;
         font-family: 'PingFang-SC-Bold';
         margin: 22px 0 14px 13px;
         display: flex;
         justify-content: flex-start;
         align-items: center;

     }
     .accounts{
         padding: 13px 14px;
         margin: 0 12px;
         background-color: #fff;
         .each-account{
             display: flex;
             justify-content: space-between;
             height: 50px;
             align-items: center;
            img{
                width: 25px;
                height: 25px;
                margin-right: 12px;
            }
            .account-name{
                font-size: 15px;
                display: flex;
                justify-content: flex-start;
                flex: 1;
            }
            .choose-box{
                width: 22px;
                height: 20px;
                border-radius: 50%;
                border: 1px solid #e7e7e7;
                img{
                    
                width: 22px;
                height: 20px;
                }
            }
         }
     }
     .xieyi{
         display: flex;
         margin: 25px 19px;
         justify-content: flex-start;
         text-align: left;
         align-items: flex-start;
         /deep/.van-checkbox{
             margin-right: 10px;
             width: 28px;
         }
         div{
             color: #A4A4A4;
             span{
                 color: @colorFont;
             }
         }
     }
     .btnbox{
         padding: 12px 15px;
     }
     .dialog-box{
         display: flex;
         justify-content: center;
         align-items: center;
         height: 100%;
         .wrapper{
             width: 325px;
            background-color: #fff;
            border-radius: 10px;
            overflow: hidden;
            position: relative;
            .dialog-title{
                // height: 81px;
                padding: 19px 22px 22px 20px;
                font-size: 15px;
                background-color: @colorBg;
                text-align: left;
                line-height: 25px;
                span{
                    font-weight: bold;
                }
            }
            .dialog-msg{
                line-height: 22.5px;
                padding: 12px 20px;
                text-align: left;
                height: 320px;
                overflow-y: scroll;
                padding-bottom: 100px;
                div{
                    margin-bottom: 22px;
                }
            }
            .dialog-btn{
                height: 100px;
                padding: 25px 18px;
                position: absolute;
                bottom: 0px;
                width: 100%;
                background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0.8) 40%, rgba(255, 255, 255, 0.9) 20%, rgba(255, 255, 255, 1) 98%, #FFFFFF 100%);
               
            }
         }
     }
 }

</style>
